import styled from 'styled-components';
import WebFont from 'webfontloader';
WebFont.load({
    google: {
        families: ['Poppins:300,400,500,600&display=swap'],
    },
});
const StyledBoxGrid = styled.div `
  display: ${({ display }) => display || 'grid'};
  grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns || '1fr'};
  grid-template-rows: ${({ gridTemplateRows }) => gridTemplateRows || 'auto'};
  grid-auto-flow: ${({ gridAutoFlow }) => gridAutoFlow || 'row'};
  gap: ${({ gap }) => gap || '1rem'};
  justify-items: ${({ justifyItems }) => justifyItems || 'stretch'};
  align-items: ${({ alignItems }) => alignItems || 'stretch'};
  align-content: ${({ alignContent }) => alignContent || 'stretch'};
  grid-column: ${({ gridColumn }) => gridColumn || 'auto'};
  grid-row: ${({ gridRow }) => gridRow || 'auto'};
  grid-column-start: ${({ gridColumnStart }) => gridColumnStart || 'auto'};
  grid-column-end: ${({ gridColumnEnd }) => gridColumnEnd || 'auto'};
  grid-row-start: ${({ gridRowStart }) => gridRowStart || 'auto'};
  grid-row-end: ${({ gridRowEnd }) => gridRowEnd || 'auto'};
  font-family: 'Poppins', sans-serif;

  font-weight: ${({ weight }) => {
    switch (weight) {
        case 'light':
            return 300;
        case 'normal':
            return 400;
        case 'semibold':
            return 500;
        case 'bold':
            return 600;
        default:
            return 400;
    }
}};
`;
export default StyledBoxGrid;
//# sourceMappingURL=styled.js.map